export default __webpack_public_path__ + "static/media/le_croise6.280902dc.jpg";